export const addressFormatter = ({
  street = '',
  city = '',
  state = '',
  zip = '',
}: {
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
}): string => {
  let formattedAddress = '';

  if (street) {
    formattedAddress += street;
  }

  if (city) {
    formattedAddress += formattedAddress ? ', ' + city : city;
  }

  if (state) {
    formattedAddress += formattedAddress ? ', ' + state : state;
  }

  if (zip) {
    formattedAddress += formattedAddress ? ' ' + zip : zip;
  }

  return formattedAddress;
};

export const reportDetailsBreadcrumbAddressFormatter = ({
  street = '',
  city = '',
  state = '',
  zip = '',
}: {
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
}): string => {
  let formattedAddress = addressFormatter({ street, city, state, zip });

  return formattedAddress === '' ? '' : ` - ${formattedAddress}`;
};
